import React, { useEffect } from "react";
import styles from "./carouselModal.module.css";
import useEmblaCarousel from 'embla-carousel-react'
import {
    PrevButton,
    NextButton,
    usePrevNextButtons
} from './carouselArrowButtons'
import {
    SelectedSnapDisplay,
    useSelectedSnapDisplay
} from './carouselSelectedSnapDisplay'

function CarouselModal(props) {
    const { slides, options, initialIndex, onClose } = props
    const [emblaRef, emblaApi] = useEmblaCarousel(options)
    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi)
    const { selectedSnap, snapCount } = useSelectedSnapDisplay(emblaApi)

    useEffect(() => {
        if (emblaApi) {
            emblaApi.scrollTo(initialIndex);
        }
    }, [emblaApi, initialIndex]);

    return (
        <div className={styles.modal}>
            <section className={styles.embla}>
                <div className={styles.embla__viewport} ref={emblaRef}>
                    <div className={styles.embla__container}>
                        {slides.map((slide, index) => (
                            <div className={styles.embla__slide} key={index}>
                                <img src={slide.src} alt={`Slide ${index}`} className={styles.embla__image} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.embla__controls}>
                    <div className={styles.embla__buttons}>
                        <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                        <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                    </div>
                    <SelectedSnapDisplay selectedSnap={selectedSnap} snapCount={snapCount} />
                </div>
                <button className={styles.closeButton} onClick={onClose}>Close</button>
            </section>
        </div>
    );
}

export default CarouselModal;